/* Juvelore: Form Indeksi bileseni (ana sayfa bolumu sections/jv-form-indeksi, Alyans mega menusu snippets/mega-menu).
   Fareli ekranda isme gelince (ya da klavyeyle odaklaninca) arka plan o ogenin gorseline gecer.
   Dokunmatikte gorsel 2,5 sn'de bir siradakine gecer; "hareketi azalt" acikken gecmez.
   "tembel" ozniteligi (mega menu): gorseller bilesen ilk kez ekranda gorununce yuklenir; kapali menu her sayfada fotograf indirmez.
   Gorseller bulanik on izlemeden netlesir (.jv-fi__img.is-loaded). */
if (!customElements.get('jv-form-indeksi')) {
  customElements.define('jv-form-indeksi', class extends HTMLElement {
    connectedCallback() {
      this.linkler = [...this.querySelectorAll('[data-jv-fi-oge]')];
      this.gorseller = [...this.querySelectorAll('[data-jv-fi-gorsel]')];
      if (!this.linkler.length) return;

      this.resimler = [...this.querySelectorAll('.jv-fi__img')];
      this.resimler.forEach((img) => {
        if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
        else img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      });

      if (this.hasAttribute('tembel') && 'IntersectionObserver' in window) {
        this.yukleyici = new IntersectionObserver(([giris]) => {
          if (giris.isIntersecting) { this.yukle(); this.yukleyici.disconnect(); }
        });
        this.yukleyici.observe(this);
      } else {
        this.yukle();
      }

      this.sec(0);

      this.linkler.forEach((link, i) => {
        link.addEventListener('mouseenter', () => { if (this.fareli()) { this.durdur(); this.sec(i); } });
        link.addEventListener('focus', () => { this.durdur(); this.sec(i); });
      });

      /* gecis hemen baslar; bilesen ekrandan cikinca durur, donunce surer */
      if (!this.fareli() && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.baslat();
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(([giris]) => { giris.isIntersecting ? this.baslat() : this.durdur(); }, { threshold: [0, .4] });
          requestAnimationFrame(() => this.io.observe(this));
        }
      }
    }

    disconnectedCallback() {
      this.durdur();
      if (this.io) this.io.disconnect();
      if (this.yukleyici) this.yukleyici.disconnect();
    }

    /* ilk gorsel hemen, digerleri o yuklendikten sonra (tembel yukleme gizli gorselleri hic baslatmiyordu) */
    yukle() {
      if (this.yuklendi) return;
      this.yuklendi = true;
      const [ilk, ...digerleri] = this.resimler;
      const devam = () => digerleri.forEach((img) => { img.loading = 'eager'; });
      if (ilk && !(ilk.complete && ilk.naturalWidth)) {
        ilk.loading = 'eager';
        ilk.addEventListener('load', devam, { once: true });
        ilk.addEventListener('error', devam, { once: true });
      } else {
        devam();
      }
    }

    fareli() { return matchMedia('(hover: hover) and (pointer: fine)').matches; }

    sec(i) {
      this.aktif = i;
      this.linkler.forEach((l, j) => l.classList.toggle('is-active', j === i));
      /* gorseli olmayan ogede onceki fotograf kalir */
      if (this.gorseller.some((g) => +g.dataset.jvFiGorsel === i)) {
        this.gorseller.forEach((g) => g.classList.toggle('is-active', +g.dataset.jvFiGorsel === i));
      }
    }

    baslat() {
      if (this.zamanlayici) return;
      this.zamanlayici = setInterval(() => this.sec((this.aktif + 1) % this.linkler.length), 2500);
    }

    durdur() { clearInterval(this.zamanlayici); this.zamanlayici = null; }
  });
}
